import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { SessionStorageService } from '../services/session-storage.service copy';

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {

  const storageService = inject(StorageService);
  const sessionService = inject(SessionStorageService);

  if (storageService.getToken() || sessionService.getToken()) {
    
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${storageService.getToken()|| sessionService.getToken()}`,
        // 'ngrok-skip-browser-warning': 'true'
      },
    });
  }
  

  return  next(request);
};